// A task's "source" only records whether it was self-created or assigned.
// Who assigned it comes from created_by, so label it by that person's actual
// role (a super admin assigning a task is not "HR Assigned").

function assignerRole(task) {
  const role = task?.created_by?.role;
  if (role === 'super_admin') return 'Admin';
  if (role === 'hr') return 'HR';
  return null;
}

export function taskSourceLabel(task) {
  if (task?.source !== 'hr_assigned') return 'Self Created';
  const role = assignerRole(task);
  return role ? `${role} Assigned` : 'Assigned';
}

export function taskSourceShort(task) {
  if (task?.source !== 'hr_assigned') return 'Self';
  return assignerRole(task) || 'Assigned';
}
